<template>
<div>
    <NavTools />
    <div style="background-color:#fff" id='player' v-cloak>
        <Alert />
        <Spinner />
        <div class='container'>
            <div class="row">
                <div class="col-md-6">
                    <h1 id='interviewee_name'>{{videometa.user}}</h1>
                </div>
                <div class="col-xs-12 col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 tab-area-row" style="border-radius:10px;">
                    <h4 style="margin-top:40px;margin-bottom:20px;">Interview Transcript</h4>
                    <div class="alert alert-info" style="margin-bottom:20px;">
                        <i class="glyphicon glyphicon-info-sign"></i> AI-generated transcripts can sometimes fail to capture the essence of an interview the way video would.
                    </div>
                    <div class="well" style="font-size:120%;background-image:unset;background-color:white;min-height:400px;white-space:pre-wrap;">{{ivTranscript}}</div>
                </div>
            </div>
        </div>

        <nav class="navbar navbar-default navbar-fixed-bottom navbar-bottom" role="navigation">
            <div class="container text-center">
                <p class="col-xs-12 navbar-text"><span>&copy; InitialView {{ currentYear }}</span></p>
            </div>
        </nav>
    </div>
</div>
</template>

<script>

import Vue from 'vue';
import VueResource from 'vue-resource';
Vue.use(VueResource);

import NavTools from "@/components/NavTools.vue";
import ivbus from "@/utils/ivbus.js";

import {
    ivAlertMixin,
    ivSpinnerMixin,
    ivUserInfoMixin,
    ivModalMixin,
    getParameterByName,
    setSessionStorageApiToken,
} from "@/mixins/base-components-pack.js";

import { orgSupportMixin } from "@/mixins/org-support-mixin-pack.js";

import apiClient from "../utils/apiClient.js";

import Alert from "../components/Alert.vue";
import Spinner from "../components/Spinner.vue";

import env from "../utils/env.js";

require('../assets/iv-player.css');
require('../assets/player.css');

var vparam = getParameterByName('v');

var urlAddVparam = "";
if (vparam !== null) {
    urlAddVparam = "?v=" + vparam;
}


export default {

    props: [
        'staticaddr',
        'serveraddr',
        'ameliaaddr',
        'lang',
        'lang_label',
    ],

    mixins: [ivAlertMixin, ivSpinnerMixin, ivModalMixin, ivUserInfoMixin, orgSupportMixin],

    components: {
        NavTools,
        Alert,
        Spinner
    },

    data() {
        return {

          env: env,
          currentYear: new Date().getFullYear(),

          ivTranscript: '',

          videometa: {},

          urlVparam: urlAddVparam,
          ivType: "",

        }

    },
    mounted: function () {
        var that = this;
        this.fetchVideoMetadata();
        this.fetchTranscriptInfo();
    },

    methods: {

        fetchVideoMetadata: function() {
          var that = this;
          var spinId = that.spinStart();
          apiClient
            .get("/api/interview/video_info/" + urlAddVparam)
            .then(function(response) {
              that.spinStop(spinId);
              if (response.data.status == 200) {
                that.videometa = response.data;
              }
            })
            .catch(function(error) {
              that.spinStop(spinId);
            });
        },

        fetchTranscriptInfo: function () {
            var that = this;
            console.log('fetching transcript');
            var spinId = that.spinStart();
            apiClient.get('/api/interview/ai_transcript/' + urlAddVparam).then(function (response) {
                console.log(response);
                that.spinStop(spinId);
                if (response.data.status == "200") {
                    that.ivTranscript = response.data.data.transcript;
                } else {
                    that.ivTranscript = response.data.message || 'Transcript not available';
                    console.log(response.data.message);
                }
            }).catch(function (error) {
                that.spinStop(spinId);
                that.ivTranscript = 'Error loading transcript';
                console.log(error);
            });
        },
    }

}


</script>

<style lang="scss">
.vjs-picture-in-picture-control {
    visibility: hidden !important
}
.four-tab-radius {
    border-radius: 0 0 10px 10px !important;
}

#viewfinder {
	width: 100%;
	transform: scale(-1, 1);
}

.tab-area-row {
    padding: 10px 10px 10px 10px;
}

.white-box {
    border-radius: 3px;
    background-image: linear-gradient(to bottom, rgba(255, 255, 255, .5), rgba(255, 255, 255, .5));
}
.vjs-fullscreen-control {
    z-index: 999;
}

[v-cloak] {
  display: none;
}
</style>
